import { useOidcStore } from 'src/stores/oidc';
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';

export function useAccessToken() {
  const oidcStore = useOidcStore();
  const { access_token } = storeToRefs(oidcStore);

  const token = ref('');

  watch(
    access_token,
    (newVal) => {
      token.value = newVal;
    },
    {
      immediate: true,
    },
  );

  return {
    token,
  };
}
